module.exports = __webpack_public_path__ + "img/08_WebFlow_02.fb2287d2.jpg";